import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login'
import manage from '@/pages/manage'
const workBench = () => import('@/pages/workBench/workBench')
const companyInfo = () => import('@/pages/companyInfo/companyInfo')
const darenInfo = () => import('@/pages/darenInfo/darenInfo')
const darenHeadline = () => import('@/pages/headLines/headLines')
const darenZhanzhang = () => import('@/pages/darenZhanzhang/darenZhanzhang')
const darenCash = () => import('@/pages/darenInfo/darenCash')
const applyZhanzhang = () => import('@/pages/applyZhanzhang/applyZhanzhang')
const orderInfo = () => import('@/pages/orderInfo/orderInfo')
const orderDetail = () => import('@/pages/orderInfo/orderDetail')
const orderSetting = () => import('@/pages/orderSetting/orderSetting')
const companyPay = () => import('@/pages/companyPay/companyPay')
const darenModule = () => import('@/pages/darenModule/darenModule')
const contactKefu = () => import('@/pages/contactKefu/contactKefu')
const inviteReward = () => import('@/pages/invitation/inviteReward')
const flowStatistics = () => import('@/pages/flowStatistics/flowStatistics')
const h5SetImg = () => import('@/pages/h5SetImg/h5SetImg')
const homeShowData = () => import('@/pages/setHomeShowData/setShowData')
const joininCompany = () => import('@/pages/joininCompany/joininCompany')
const joininComDetail = () => import('@/pages/joininCompany/joininComDetail')
const setSystemValue = () => import('@/pages/setSystemValue/setSystemValue')
const award = () =>import('@/pages/award/award')
const draw = () => import('@/pages/draw/draw')
const drawDetail = () => import('@/pages/draw/drawDetail')
const setDraw = () => import('@/pages/draw/setDraw')
const gift = () => import('@/pages/gift/gift')
const exChange = () => import('@/pages/exChange/exChange')
const goldFlow = () => import('@/pages/exChange/goldFlow')
const role = () => import('@/pages/role/role')
const daily = () => import('@/pages/role/daily')
const user = () => import('@/pages/role/user')
const password = () => import('@/pages/role/modifyPassword')
const renew = () => import('@/pages/renew/renew')
const page401 = () => import('@/pages/errorPage/401')
const notFound = () => import('@/pages/errorPage/404')


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/manage',
      name: 'manage',
      component: manage,
      children: [
        {
          path: '/workBench',
          component: workBench,
          meta: ['工作台']
        },
        {
          path: '/companyInfo',
          component: companyInfo,
          meta: ['管理', '企业管理']
        },
        {
          path: '/darenInfo',
          component: darenInfo,
          meta: ['管理', '达人管理']
        },
        {
          path: '/darenCash',
          component: darenCash,
          meta: ['管理', '达人提现管理']
        },
        {
          path: '/darenHeadline',
          component: darenHeadline,
          meta: ['管理', '达人头条管理']
        },
        {
          path: '/darenZhanzhang',
          component: darenZhanzhang,
          meta: ['管理', '站长管理']
        },
        {
          path: '/applyZhanzhang',
          component: applyZhanzhang,
          meta: ['管理', '站长申请管理']
        },
        {
          path: '/orderInfo',
          component: orderInfo,
          meta: ['管理', '订单管理']
        },
        {
          path: '/orderDetail/:id',
          component: orderDetail,
          meta: ['管理', '订单管理','订单详情']
        },
        {
          path: '/joinComDetail/:id',
          component: joininComDetail,
          meta: ['管理', '招商加盟管理', '查看申请信息']
        },
        {
          path: '/award',
          component: award,
          meta: ['管理', '奖品管理']
        },
        {
          path: '/draw',
          component: draw,
          meta: ['管理', '抽奖管理']
        },
        {
          path: '/drawDetail/:id',
          component: drawDetail,
          meta: ['管理', '抽奖管理', '查看中奖信息']
        },
        {
          path: '/setDraw',
          component: setDraw,
          meta: ['管理', '抽奖管理', '奖品设置']
        },
        {
          path: '/gift',
          component: gift,
          meta: ['管理', '礼品管理']
        },
        {
          path: '/exchange',
          component: exChange,
          meta: ['管理', '兑换管理']
        },
        {
          path: '/goldflow',
          component: goldFlow,
          meta: ['管理', '金币流水']
        },
        {
          path: '/orderSetting',
          component: orderSetting,
          meta: ['设置', '订单模块']
        },
        {
          path: '/companyPay',
          component: companyPay,
          meta: ['设置', '企业付费']
        },
        {
          path: '/darenModule',
          component: darenModule,
          meta: ['设置', '达人模块']
        },
        {
          path: '/contactKefu',
          component: contactKefu,
          meta: ['设置', '客服信息']
        },
        {
          path: '/inviteReward',
          component: inviteReward,
          meta: ['设置', '邀请有奖']
        },
        {
          path: '/h5Setimg',
          component: h5SetImg,
          meta: ['设置', 'H5页面']
        },
        {
          path: '/homeShowData',
          component: homeShowData,
          meta: ['设置', '首页展示数据']
        },
        {
          path: '/setSystemValue',
          component: setSystemValue,
          meta: ['设置', '系统变量']
        },
        {
          path: '/role',
          component: role,
          meta: ['用户角色', '权限管理']
        },
        {
          path: '/user',
          component: user,
          meta: ['用户角色', '用户管理']
        },
        {
          path: '/daily',
          component: daily,
          meta: ['用户角色', '操作日志']
        },
        {
          path: '/flowStatistics',
          component: flowStatistics,
          meta: ['流水统计', '流水明细']
        },
        {
          path: '/modifyPassword',
          component: password,
          meta: ['用户', '修改密码']
        },
        {
          path: '/renew',
          component: renew,
          meta: ['系统续费']
        }

      ]
    },
    {
      path: '/401',
      component: page401,
    },
    {
      path: '/404',
      component: notFound,
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js